<template>
  <div class="static flex-full">
    <div class="static-line">
      <h1 class="static-line-title"> {{ $t(title) }} </h1>
    </div>
    <div class="static-content">
      <div class="static-content-inner" :class="{ fullWidth: otherPage }">

        <!-- Navigation panel -->
        <aside class="static-content-aside" v-if="!otherPage">
          <nav class="static-content-aside-menu">
            <ul>
              <li class="static-content-aside-menu-item" v-for="route in navigation">
                <router-link class="static-content-aside-menu-item-link no-underline"
                             :class="{ active: $route.path === route.link }"
                             :to="localizedRoute(route.link)"
                             v-if="route.link !== '/main-values'"
                > {{ $t(route.title) }} </router-link>
              </li>
            </ul>
          </nav>
        </aside>

        <!-- Content -->
        <section class="static-content-block">
          <component :is="activeComponent" :isActive="true" />
        </section>

      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@vue-storefront/i18n';
import { localizedRoute } from '@vue-storefront/core/lib/multistore';
import StaticAboutUs from 'theme/components/theme/blocks/Static/AboutUs';
import FAQ from 'theme/components/theme/blocks/Static/FAQ';
import StaticContacts from 'theme/components/theme/blocks/Static/Contacts';
import StaticUmoviDostavku from 'theme/components/theme/blocks/Static/UmoviDostavku';
import StaticTermsOfUse from 'theme/components/theme/blocks/Static/TermsOfUse';
import StaticPrivacy from 'theme/components/theme/blocks/Static/Privacy';
import StaticVacancies from 'theme/components/theme/blocks/Static/Vacancies';
import StaticCourierRegister from 'theme/components/theme/blocks/Static/CourierRegister';
import StaticMainValues from 'theme/components/theme/blocks/Static/MainValues';

export default {
  metaInfo () {
    return {
      title: this.$t(this.$route.meta.title) || this.$t(this.$props.title),
      meta: this.$route.meta.description ? [{vmid: 'description', description: this.$route.meta.description}] : []
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    page: {
      type: String,
      required: true
    }
  },
  computed: {
    activeComponent () {
      const matchedNav = this.navigation.find(nav => nav.link === this.$route.path);
      return matchedNav ? matchedNav.component : null;
    },
    otherPage () {
      return this.$route.name === 'contacts' || this.$route.name === 'main-values';
    }
  },
  data () {
    return {
      navigation: [
        { title: i18n.t('About us'), link: '/about-us', component: StaticAboutUs },
        { title: i18n.t('Contact us'), link: '/contacts', component: StaticContacts },
        { title: i18n.t('Delivery and payment'), link: '/umovi-dostavki', component: StaticUmoviDostavku },
        { title: i18n.t('Terms of use'), link: '/terms-of-use', component: StaticTermsOfUse },
        { title: i18n.t('Privacy'), link: '/privacy', component: StaticPrivacy },
        { title: i18n.t('FAQ'), link: '/FAQ', component: FAQ },
        { title: i18n.t('Vacancies'), link: '/vacancies', component: StaticVacancies },
        { title: i18n.t('Main values'), link: '/main-values', component: StaticMainValues }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .static {
    width: 100%;

    display: flex;
    flex-direction: column;

    &-line {
      height: 40px;

      position: relative;

      display: flex;
      justify-content: center;

      background-image: url('/assets/static/header/pille-riin-priske-9-el-mi-ar-pj-vq-unsplash.png');
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;

      &::before {
        margin: auto;

        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;

        content: '';
        background: rgba(0, 0, 0, .5);
      }

      &-title {
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        text-align: center;

        z-index: 1;
      }
    }

    &-content {
      width: 100%;

      display: flex;
      justify-content: center;

      &-inner {
        width: 1154px;

        display: flex;
        justify-content: space-between;
        @media only screen and (max-width: 1200px) {
          width: 962px;
        }

        @media only screen and (max-width: 991px) {
          width: 722px;
        }

        @media only screen and (max-width: 768px) {
          width: 560px;
        }

        @media only screen and (max-width: 576px) {
          width: 100%;
        }
        &.fullWidth {
          width: 100%;
          justify-content: center;
        }
      }

      &-aside {
        margin-top: 40px;
        margin-right: 30px;

        @media only screen and (max-width: 1023px) {
          display: none;
        }

        &-menu {
          width: 262px;
          background: #f5f5f5;

          ul {
            margin: 0;
            padding: 20px;
            padding-bottom: 5px;

            list-style: none;
          }

          &-item {
            width: 100%;

            & + &:not(:last-child) {
              margin: 15px 0;
            }

            &-link {
              width: 100%;

              position: relative;
              display: inline-flex;

              font-size: 14px;
              line-height: 25px;

              transition: .2s;

              &.active {
                color: #11bb2e;

                &::before {
                  height: 1px;
                }
              }

              &::before {
                width: 100%;
                height: 0;

                margin: 0 auto;

                position: absolute;
                left: 0;
                right: 0;
                bottom: -1px;

                content: '';
                background: #11bb2e;
              }

              &:hover {
                cursor: pointer;
                color: #11bb2e;
              }
            }
          }
        }
      }

      &-block {
        width: 100%;
      }
    }
  }
</style>
